import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';

export interface IDataGridDisplayAccount extends IAccount {
    displayName: string;
    isDuplicateAccountNumber?: boolean;
    isSummarized?: boolean;
    isEndOfDuplicateAccounts?: boolean;
}
